export interface Practitioner {
  id: string;
  name: string;
  type: string;
  category: string;
  district: string;
  address: string;
  phone?: string;
  price: number;
  conventionCode: string;
  nextSlot: string;
  isAvailableNow: boolean;
  tags: string[];
  initials: string;
  color: string;
  whatsapp?: string;
  subscriptionTier?: string;
  rating?: number;
  reviews?: number;
}

// L'annuaire est désormais alimenté directement par la base de données
// (table « practitioners »). Les données de démonstration ont été retirées.
export const practitioners: Practitioner[] = [];

// Liste canonique des spécialités / métiers présente dans la base.
// Elle alimente les filtres et la génération d'URL SEO (ex. /rabat/agdal/cardiologue).
export const specialties = [
  'Médecin généraliste', 'Cardiologue', 'Dermatologue', 'Pédiatre', 'Gynécologue',
  'Dentiste', 'Ophtalmologue', 'ORL', 'Gastro-entérologue', 'Rhumatologue',
  'Neurologue', 'Psychiatre', 'Urologue', 'Endocrinologue', 'Orthopédiste',
  'Laboratoire d\'analyses', 'Radiologie', 'Pharmacie', 'Kinésithérapeute',
  'Orthophoniste', 'Ostéopathe', 'Infirmier à domicile',
];

// Quartiers couverts par l'annuaire à Rabat.
export const districts = [
  'Agdal', 'Hassan', 'Hay Riad', 'Souissi',
  'L\'Océan', 'Youssoufia', 'Yacoub El Mansour',
];